// import { createMovieClip } from "../../functions/Functions_General";

import { createMovieClip } from "../../../../common/functions/Functions_General";

export class smallWinAnimationSergio {
  private parent: PIXI.Container;
  private shockwave: Array<PIXI.extras.AnimatedSprite>;
  private winAmountText: PIXI.Text;
  private winAnimation: PIXI.tween.Tween;
  private winAnimationExit: PIXI.tween.Tween;
  private shockWave2Image: PIXI.Sprite;
  private shockWave2ImageTween: PIXI.tween.Tween;
  private shockwaveContainer: PIXI.Container = new PIXI.Container();
  private labelsWins: Array<string> = ["YOU WIN!", "NICE WIN!", "GREAT WIN!"];
  private multiplier: Array<number> = [5, 10, 15];

  private textWinRank: PIXI.Text;
  private sergioDanceStop: PIXI.extras.AnimatedSprite;
  private sergioContainer: PIXI.Container = new PIXI.Container();
  constructor(parent: PIXI.Container) {
    this.parent = new PIXI.Container();

    parent.addChild(this.shockwaveContainer);
    parent.addChild(this.sergioContainer);

    parent.addChild(this.parent);
    this.shockwave = [];
    //-filter to retint
    let colorMatrix = new PIXI.filters.ColorMatrixFilter();

    colorMatrix.colorTone(0, 0xff0000, "0xfffff", "0x0000ff", true);

    for (let i = 0; i < 4; i++) {
      this.shockwave[i] = createMovieClip("shockWaveAnimated", 0, 29);
      this.shockwave[i].animationSpeed = .35;
      this.shockwave[i].anchor.set(0);
      this.shockwave[i].scale.set(1);
      this.shockwave[i].blendMode = PIXI.BLEND_MODES.ADD;
      //   this.shockwave[i].rotation=Math.PI/2*i
      this.shockwave[i].loop = false;
      this.shockwave[i].gotoAndStop(0);
      this.shockwaveContainer.addChild(this.shockwave[i]);
      //   this.shockwave[i].filters = [colorMatrix];
    }
    this.shockwave[1].scale.set(-1, 1);
    this.shockwave[2].scale.set(-1, -1);
    this.shockwave[3].scale.set(1, -1);

    this.shockWave2Image = new PIXI.Sprite(
      PIXI.Texture.fromFrame("ZoomingFx.png")
    );
    this.shockWave2Image.anchor.set(0.5);
    this.shockWave2Image.blendMode = PIXI.BLEND_MODES.ADD;

    this.shockWave2ImageTween = PIXI.tweenManager.createTween(
      this.shockWave2Image
    );
    this.shockWave2ImageTween
      .from({ scale: { x: 0, y: 0 }, alpha: 1 })
      .to({ scale: { x: 2, y: 2 }, alpha: 0 });
    this.shockWave2ImageTween.easing = PIXI.tween.Easing.outSine();
    this.shockWave2ImageTween.time = 1000;
    // this.shockWave2ImageTween.repeat=1;
    this.shockWave2ImageTween.stop();

    this.parent.addChild(this.shockWave2Image);
    let textStyle = new PIXI.TextStyle({
      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontSize: 120,
      // fill: ["#fffb93", "#f8ee6f",  "#965135","#fffb93"],
      fill: ["#ffffff", "#ccccee"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      stroke: "#1a1a1a",
      strokeThickness: 15,
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 30,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    let textStyle2 = new PIXI.TextStyle({
      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontSize: 150,
      fill: ["#ffffff", "#ccccee"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      stroke: "#1a1a1a",
      strokeThickness: 15,
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 30,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    this.winAmountText = new PIXI.Text("0.00€", textStyle);
    this.parent.addChild(this.winAmountText);

    this.winAmountText.anchor.set(0.5);
    // this.winAmountTextTop.anchor.set(0.5);

    this.parent.scale.set(1);
    this.winAnimation = PIXI.tweenManager.createTween(this.winAmountText);
    this.winAnimation
      .from({ scale: { x: 0.9, y: 0.9 }, y: 0 })
      .to({ scale: { x: 1, y: 0.95 }, y: 0 });
    this.winAnimation.easing = PIXI.tween.Easing.outExpo();
    this.winAnimation.time = 1000;
    this.winAnimation.stop();
    this.winAnimation.repeat = 0;
    this.winAnimation.pingPong = true;

    this.winAnimationExit = PIXI.tweenManager.createTween(this.winAmountText);
    this.winAnimationExit
      .from({ scale: { x: 0.9, y: 0.9 }, y: 0, alpha: 1 })
      .to({ scale: { x: 1, y: 1 }, y: -50, alpha: 0 });
    this.winAnimationExit.easing = PIXI.tween.Easing.outExpo();
    this.winAnimationExit.time = 1000;
    this.winAnimation.chain(this.winAnimationExit);

    // this.winAnimation.on("start",    this.startAnimation );

    this.textWinRank = new PIXI.Text(this.labelsWins[0], textStyle2);
    this.textWinRank.anchor.set(0.5);
    this.textWinRank.y = -this.winAmountText.height;
    this.multiplier;
    // this.winAmountText.addChild(this.textWinRank);

    let spacingAnimation = PIXI.tweenManager.createTween(textStyle2);
    // textStyle2.letterSpacing
    spacingAnimation.from({ letterSpacing: 0 }).to({ letterSpacing: 3 });
    spacingAnimation.easing = PIXI.tween.Easing.inOutSine();
    spacingAnimation.time = 1000;
    spacingAnimation.start();
    // spacingAnimation.repeat=2;
    spacingAnimation.loop = true;
    spacingAnimation.pingPong = true;
    this.createSergio();
    this.clear();
  }
  private createSergio = (): void => {
    this.sergioDanceStop = createMovieClip("sergioDanceStop", 0, 41);
    this.sergioContainer.addChild(this.sergioDanceStop);
    this.sergioDanceStop.anchor.set(0.5);
    this.sergioDanceStop.loop = false;
    // this.sergioDanceStop.=true;
    this.sergioDanceStop.scale.set(1.2);
    this.sergioDanceStop.gotoAndStop(0);
    this.sergioDanceStop.y = -75;
    this.sergioDanceStop.animationSpeed = 0.5;
    this.sergioDanceStop.alpha = 0;
    // this.sergioDanceStop.gotoAndPlay(0);

    this.sergioDanceStop.onComplete = this.hideSergio;
  };
  private hideSergio = (): void => {
    this.sergioDanceStop.alpha = 0;
    this.sergioDanceStop.gotoAndStop(0);
  };

  public setPosition = (newPosition: Array<number>): void => {
    this.parent.position.set(newPosition[0], newPosition[1]);
    this.shockwaveContainer.position.set(newPosition[0], newPosition[1]);
    this.sergioContainer.position.set(newPosition[0], newPosition[1]);
  };

  public playShockWave = (bool: boolean): void => {

    if (bool) {
      this.winAmountText.alpha = 1;
      this.shockWave2Image.alpha = 1;
      this.winAnimation.reset();
      this.winAnimation.start();
      this.shockWave2ImageTween.start();
      this.shockwave[0].gotoAndPlay(15);
      this.shockwave[1].gotoAndPlay(15);
      this.shockwave[2].gotoAndPlay(15);
      this.shockwave[3].gotoAndPlay(15);
      this.shockwaveContainer.alpha = 1;

      this.sergioDanceStop.alpha = 1;
      this.sergioDanceStop.gotoAndPlay(0);
    } else {
      this.winAmountText.alpha = 0;
      this.winAnimation.stop();
      this.winAnimationExit.stop();
      this.shockWave2ImageTween.stop();
      this.shockWave2Image.alpha = 0;
      this.shockwaveContainer.alpha = 0;
      this.shockwave[0].gotoAndStop(0);
      this.shockwave[1].gotoAndStop(0);
      this.shockwave[2].gotoAndStop(0);
      this.shockwave[3].gotoAndStop(0);
      this.sergioDanceStop.alpha = 0;
      this.sergioDanceStop.gotoAndStop(0);
    }
    // for (let i = 0; i < this.shockwave.length; i++) {
    //   this.shockwave[i].alpha = bool ? 1 : 0;
    //   this.shockwave[i].alpha>0 ? this.shockwave[i].gotoAndPlay(1):this.shockwave[i].gotoAndStop(0);
    // };
  };

  public updatewinAmountText = (winSText: string, multiplier: number): void => {
    this.shockwaveContainer.scale.set(0);
    let index = -1;
    for (let i = 0; i < this.multiplier.length; i++) {
      if (multiplier >=this.multiplier[i]) {
        this.textWinRank.text = this.labelsWins[i];
        this.shockwaveContainer.scale.set(.75+i*.1);
        index++;
      } else if (multiplier < this.multiplier[0]) {
        this.textWinRank.text = "";
        this.shockwaveContainer.scale.set(0.65);
      }
    }
    //-display sergio only on BIG WIN 
    if (index == this.multiplier.length - 1) {
      this.sergioContainer.alpha = 0;
    } else {
      this.sergioContainer.alpha = 0;
    }

   
    let setVisible=multiplier >= this.multiplier[0];
    this.textWinRank.alpha =setVisible? 1 : 0;    
    // this.textWinRank.alpha = multiplier >= this.multiplier[0] ? 1 : 0;
    this.winAmountText.text = winSText;

    this.playShockWave(setVisible);
  };
  public clear = (): void => {
    this.playShockWave(false);
  };
}
